export const dataDisabled = (disabled: boolean | undefined) =>
	disabled ? { "data-disabled": "" } : {};

export const dataOpen = (open: boolean | undefined) => (open ? { "data-open": "" } : {});
